import { observer } from "mobx-react";
import { useRootStore } from "@/stores/RootStoreContext";
import { isAnonymousRoute } from "./routes";
import LoginPage from "@/Login/LoginPage";
import BankIdLoginSweden from "@/Login/BankIdLoginSweden";
import LoginCallbackPage from "@/Login/LoginCallbackPage";
import SsoAccountSelectionPage from "@/Login/SsoAccountSelectionPage";
import SigningCompletedBankIdCallbackPage from "@/signing/SigningCompletedBankIdCallbackPage";
import SigningCompletePage from "@/signing/SigningCompletePage";
import PasswordResetPage from "@/Login/PasswordResetPage";
import SignDocumentPage from "@/signing/SignDocumentPage";
import SubscriptionFormSign from "@/views/Pages/SubscriptionFormSign";
import NoticeForBoardMemberPage from "@/noticeForBoardMember/NoticeForBoardMemberPage";
import ReviewMinutesInitializer from "@/meetings/ReviewMinutesPageParticipant";
import PowerOfAttorneyRecipientPage from "@/meetings/generalMeeting/PowerOfAttorneyRecipientPage";
import NoticeForShareholderPage from "@/meetings/generalMeeting/NoticeForShareholderPage";
import CreatePasswordPage from "@/views/UserSettings/CreatePasswordPage";
import InvitationPage, { BatchInvitationPage } from "@/views/Pages/Invitation/InvitationPage";
import AffiliatePageInitialiser from "@/affiliate/AffiliateStartPage";
import { DocumentForViewingPage } from "@/document/DocumentForViewingPage";

export const AnonymousRoutesView = observer(() => {
  const rootStore = useRootStore();
  const route = rootStore.route && isAnonymousRoute(rootStore.route) ? rootStore.route : undefined;

  switch (route?.name) {
    case "login":
      return <LoginPage />;
    case "login-sweden":
      return <BankIdLoginSweden />;
    case "login-callback":
      return <LoginCallbackPage />;
    case "sso-account-selection":
      return <SsoAccountSelectionPage />;
    case "signing-completed-bankid-callback":
      return <SigningCompletedBankIdCallbackPage />;
    case "signing-complete":
      return <SigningCompletePage />;
    case "forgot-password":
      return <PasswordResetPage queryParams={route.queryParams} />;
    case "sign":
      return <SignDocumentPage />;
    case "subscription-form":
      return <SubscriptionFormSign queryParams={route.queryParams} />;
    case "notice-board-meeting":
      return <NoticeForBoardMemberPage noticeDocumentId={route.params.noticeDocumentId} />;
    case "board-minutes-review/matter":
      return <ReviewMinutesInitializer {...route.params} />;
    case "board-minutes-review":
      return <ReviewMinutesInitializer {...route.params} />;
    case "notice-genera-meeting/poa-recipient":
      return <PowerOfAttorneyRecipientPage {...route.params} />;
    case "notice-general-meeting":
      return <NoticeForShareholderPage {...route.params} />;
    case "create-password":
      return <CreatePasswordPage />;
    case "invitation":
      return <InvitationPage {...route.params} />;
    case "batch-invitation":
      return <BatchInvitationPage {...route.params} />;
    case "affiliate":
      return <AffiliatePageInitialiser {...route.params} />;
    case "document-for-viewing":
      return <DocumentForViewingPage {...route.params} {...route.queryParams} />;
    default:
      return null;
  }
});
